import { render } from "./StagnantProducts.vue?vue&type=template&id=7326991c"
import script from "./StagnantProducts.vue?vue&type=script&lang=js"
export * from "./StagnantProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__